export default {
    "title": "🇸🇪 Svenska",
    "首页": "Hem",
    "关于": "Om",
    "会员": "Medlemskap",
    "推荐计划": "Rekommendationsprogram",
    "个人": "Profil",
    "推荐": "Rekommendation",
    "预订": "Boka nu",
    "事件": "Evenemang",
    "登出": "Logga ut",
    "登录": "Logga in",
    "注册": "Registrera",
    "我们的应用程序现在可用": "Vår app är nu tillgänglig",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "För en bättre upplevelse har vi just lanserat vår mobilapp för sömlös och snabbare bokning.",
    "iOS版下载（即将推出）": "Ladda ner för iOS (Kommer snart)",
    "Android版下载（即将推出）": "Ladda ner för Android (Kommer snart)",
    "为什么选择我们": "Varför välja oss",
    "我们卓越的服务。": "Våra utmärkta tjänster.",
    "收入最高的酒店": "Högst intäkter attraktioner",
    "我们的合作酒店收入最高。": "Våra samarbetande attraktioner med högsta intäkter.",
    "回报": "Avkastningar",
    "最具特色的酒店": "Mest framträdande attraktioner",
    "我们平台上最有特色的酒店。": "Mest framträdande hotell på vår plattform.",
    "热门国家和目的地": "Topp länder och destinationer",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "Upptäck några av de bästa tipsen från staden från våra partners och vänner.",
    "酒店": "Attraktioner",
    "预订酒店并开始赚取": "Utforska världen med oss!",
    "让我们开始与TitanTraveler一起探索世界": "Förbered dig för att utforska världen av attraktioner med oss!",
    "客户评价": "Uttalanden",
    "查看我们用户的真实评价。": "Kolla våra autentiska uttalanden från våra användare.",
    "银行卡列表": "Bankkortlista",
    "银行列表": "Banklista",
    "持卡人姓名": "Kortinnehavarens namn",
    "银行卡号": "Bankkonto (IBAN)",
    "支付密码": "Betalningslösenord",
    "提交": "Skicka",
    "Pix列表": "Pix-lista",
    "Pix类型": "Pix-typ",
    "Pix账号": "Pix-konto",
    "账号列表": "Kontolista",
    "网络": "Nätverk",
    "地址": "Adress",
    "备注": "Notera",
    "充值金额": "Ombokningsbelopp",
    "支付类型": "Betalningstyp",
    "支付银行": "Betalningsbank",
    "USDT地址": "USDT-adress",
    "二维码": "QR-kod",
    "充值渠道": "Ombokningskanal",
    "充值凭证": "Ombokningskupong",
    "立即登录": "Logga in nu",
    "用户名": "Användarnamn",
    "密码": "Lösenord",
    "邀请码": "Inbjudningskod",
    "确认密码": "Bekräfta lösenord",
    "手机": "Mobil",
    "注册2": "Registrera",
    "金额": "Belopp",
    "新增": "Ny",
    "我们的精彩": "Vår fantastiska",
    "故事": "Berättelse",
    "奖项": "Utmärkelser",
    "获得": "Fått",
    "钱包余额": "Plånboksbalans",
    "累计佣金": "Ackumulerad provision",
    "今日奖励": "Dagens belöningar",
    "总行程": "Totalt resande",
    "访问行程": "Besökta resor",
    "酒店历史": "Orderdetaljer",
    "单价": "Pris",
    "数量": "Antal",
    "总额": "Totalt",
    "奖励": "Belöningar",
    "上一页": "Föregående",
    "下一页": "Nästa",
    "每套预订量": "Bokningar per uppsättning",
    "预订奖励": "Bokningsbelöning",
    "每日预订": "Daglig bokning",
    "手机号码": "Telefonnummer",
    "修改密码": "Ändra lösenord",
    "登录密码": "Inloggningslösenord",
    "当前密码": "Nuvarande lösenord",
    "新密码": "Nytt lösenord",
    "确认新密码": "Bekräfta nytt lösenord",
    "保存修改": "Spara ändringar",
    "充值": "Fyll på",
    "我们的": "Vår",
    "复制": "Kopiera",
    "分享链接": "Dela länk",
    "搜索酒店": "Boka resa",
    "实际等级": "Aktuell nivå",
    "升级": "Uppgradera",
    "已完成预订": "Bokningar slutförda",
    "登录时间": "Inloggningstid",
    "信誉分": "Trohetspoäng",
    "控制菜单": "Instrumentpanelmeny",
    "提现": "Ta ut",
    "提现账号": "Uttagskonto",
    "你确定要删除此账号吗": "Är du säker på att du vill ta bort detta konto?",
    "你确定要删除此地址吗": "Är du säker på att du vill ta bort denna adress?",
    "提示": "Tips",
    "是": "Ja",
    "否": "Nej",
    "全部": "Alla",
    "待处理": "Pending",
    "冻结中": "Frysning",
    "已完成": "Slutförd",
    "订阅": "Prenumerera",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Vill du bli meddelad när vi lanserar en ny mall eller uppdatering? Registrera dig så skickar vi en e-postnotis.",
    "我们的伙伴": "Våra partners",
    "关于我们": "OM OSS",
    "实时聊天支持": "Livechattstöd",
    "在线聊天": "Livechatt",
    "创建时间": "Skapat tid",
    "你确定要登出当前账号吗？": "Vill du logga ut från det aktuella kontot?",
    "请输入你的邮箱": "Ange din e-postadress",
    "好评": "Mycket bra",
    "条评论": "Recensioner",
    "平均每晚": "Genomsnitt/Natt",
    "旅行旅程": "Resor",
    "正在寻找酒店": "Letar efter en resa",
    "开始预订": "Börja boka",
    "旅程价格": "Resans pris",
    "佣金": "Provisioner",
    "底部-about": "Vi är en digital marknadsföringsbyrå baserad i Kalifornien, USA, som gör det möjligt för företag att lyckas i den digitala världen genom innovativa och datadrivna marknadsföringsstrategier, personlig service och en tillväxttänkande som håller koll på branschtrender. Oavsett om du behöver en SEO-byrå, webbdesign, betala per klick-hantering, varumärkesstrategi, innehållsutveckling eller andra digitala marknadsföringstjänster, har Tours4fun den expertis och erfarenhet som krävs för att hjälpa dig att nå dina mål i en resultatdriven värld.",
    "立即预订": "Boka nu",
    "搜索": "Sök",
    "快乐的客户": "Nöjd kund",
    "快乐的酒店老板": "Nöjd hotellägare",
    "评论1": "Arkitektur på byggnader.",
    "评论2": "Detta är en fantastisk plats för en promenad med smala gator och vacker arkitektur på byggnaderna.",
    "评论3": "Vacker torg mellan stranden och Central Avenue.",
    "评论4": "Mycket fina byggnader med en intressant historia.",
    "评论5": "Många restauranger att välja mellan och en mycket avslappnad atmosfär.",
    "评论6": "Vacker mark med underbara apelsinlundar och djur.",
    "评论7": "Bra plats för en helgutflykt.",
    "评论8": "Intressant plats ......",
    "评论9": "En fantastisk plats att koppla av och se världen passera.",
    "评论10": "Högklassig strandklubb som är en vacker hyllning till dem som dog i kriget.",
    "评论11": "Det finns så mycket att se och det är en fantastisk plats att semestra och koppla av!",
    "评论12": "Första gången här och det var mycket trevligt, kommer tillbaka nästa gång.",
    "评论13": "Det var en annan upplevelse och kändes bra, lokalbefolkningen var mycket vänliga och artiga!",
    "推荐计划1": "Plattformsanvändare kan bjuda in andra att bli plattformsagenter genom rekommendationskoder och bli din underordnade.",
    "推荐计划2": "Som överordnad kan du ta ut en viss procentandel av din underordnades vinst, och vinsten som erhålls av överordnad kommer direkt att återföras till överordnads plattforms konto eller till teamrapporten.",
    "推荐计划3": "Obs: Alla agenter / underordnade på plattformen kommer att få en viss procentandel av plattformens vinster och belöningar i enlighet därmed, att utveckla ett team påverkar inte vinsterna och belöningarna för någon agent eller underordnade.",
    "评分": "Betyg",
    "评论": "Kommentar",
    "酒店很棒": "Hotellet är fantastiskt",
    "终于体验了，酒店非常好": "Äntligen upplevt det, hotellet är mycket bra",
    "我对酒店非常满意并推荐预订": "Jag är mycket nöjd med hotellet och rekommenderar att boka",
    "我很高兴很满意，价格实惠": "Jag är mycket glad och nöjd, priset är överkomligt",
    "服务非常好，我非常喜欢": "Servicen är mycket bra, jag gillar det verkligen",
    "体验很不错，朋友已经第二次预订了": "Upplevelsen var mycket bra, min vän har redan bokat det för andra gången",
    "酒店环境优美": "Vacker hotellmiljö",
    "酒店卫生干净": "Hotellet är hygieniskt och rent",
    "工作人员态度非常好": "Personalens attityd är mycket bra",
    "酒店服务很棒": "Hotellservicen är fantastisk",
    "你还没有设置支付密码，请前往设置": "Du har inte ställt in ett betalningslösenord, vänligen gå till inställningar",
    "订单": "Beställningar",
    "复制成功": "Kopiera framgångsrikt",
    "团队与条件": "Villkor",
    "站内信": "Platsmeddelanden",
    "请联系客服升级会员": "Vänligen kontakta kundtjänst för att uppgradera medlemskap",
    "我已阅读并同意": "Jag har läst och godkänt",
    "注册协议": "Registreringsavtal",
    "忘记密码": "Glömt lösenord",
    "账户明细": "Kontodetaljer",
    "时间": "Tid",
    "类型": "Typ",
    "代理支持": "Agentstöd",
    "冻结金额": "Fryst belopp",
    "点击下面的金蛋抽取奖励": "Klicka på det gyllene ägget nedan för att vinna priset",
    "恭喜您中奖了！": "Grattis, du vann!",
    "很遗憾，您没有中奖": "Tyvärr vann du inte",
    "公告": "Meddelande",
}